
 $("#m-1680686355510 .accordion-titel").click(function(){
    $(this).parent(".accordion-item").find(".accordion-contant").slideToggle();
    if($(this).hasClass("dp-active")){
      $(this).removeClass("dp-active"); // remove active class
    } else {
      $(this).addClass("dp-active"); // add active class
    }
  });
  // $('#m-1680686355510 .accordion-titel').each(function(index) {
  //   var accrdion_title = $(this).html();
  //   $(this).html('<span class="accord-title">' + accrdion_title + '</span>');
  //   $(this).prepend('<span class="count">' + (index + 1) + '</span>');
  // });

